import { QdeService } from "./../services/qde.service";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { QdeRoutingModule } from "./qde-routing.module";
import { AboutYourselfComponent } from "./about-yourself/about-yourself.component";
import { QdeComponent } from "./qde.component";
import { ProfessionalComponent } from "./professional/professional.component";
import { PersonalComponent } from "./personal/personal.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { OtpModelBoxComponent } from "./otp-model-box/otp-model-box.component";
import { SharedModule } from "../shared/shared.module";
import { APP_BASE_HREF } from '@angular/common';
import { CardUpgradeComponent } from './card-upgrade/card-upgrade.component';
import { CustomTooltipDirective } from '../directive/custom-tooltip.directive';
import { MatTooltipModule } from '@angular/material/tooltip';
import { QdeHeaderComponent } from './qde-header/qde-header.component';
import { ExistingUserComponent } from './existing-user/existing-user.component';
import { RetrievePopUpComponent } from './retrieve-pop-up/retrieve-pop-up.component';
import { CardUpgradePopupComponent } from './card-upgrade-popup/card-upgrade-popup.component';
import { MatCarouselModule } from '@ngmodule/material-carousel';
import { PopUpModalComponent } from './pop-up-modal/pop-up-modal.component';
import {MatDialogModule} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import { CardTrackingAndDeliveryComponent } from './card-tracking-and-delivery/card-tracking-and-delivery.component';

@NgModule({
  declarations: [
    AboutYourselfComponent,
    QdeComponent,
    ProfessionalComponent,
    PersonalComponent,
    OtpModelBoxComponent,
    RetrievePopUpComponent,
    CardUpgradeComponent,
    CustomTooltipDirective,
    QdeHeaderComponent,
    ExistingUserComponent,
    CardUpgradePopupComponent,
    PopUpModalComponent,
    CardTrackingAndDeliveryComponent,
  ],
  imports: [
    CommonModule,
    //changes done for remove lazsy loading 
    //   QdeRoutingModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    MatTooltipModule,
    MatDialogModule,
    MatButtonModule,
    MatCarouselModule.forRoot()
  ],
  exports: [
    AboutYourselfComponent,
    QdeComponent,
    ProfessionalComponent,
    PersonalComponent,
    OtpModelBoxComponent,
    RetrievePopUpComponent,
    //changes done for remove lazy loading 
    CardUpgradeComponent,
    CustomTooltipDirective,
    QdeHeaderComponent,
    ExistingUserComponent,
    CardUpgradePopupComponent,
    CardTrackingAndDeliveryComponent,
  ],
  providers: [
    QdeService,
    { provide: APP_BASE_HREF, useValue: window.location.pathname },
  ],
  entryComponents: [OtpModelBoxComponent, RetrievePopUpComponent, CardUpgradePopupComponent, PopUpModalComponent]
})
export class QdeModule { }
